/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ProjectFinancialsPage_QueryVariables = {
    projectId?: string | null | undefined;
    currentYear?: number | null | undefined;
    currentMonth?: number | null | undefined;
    currentMonthLastDay?: number | null | undefined;
};
export type ProjectFinancialsPage_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly project: {
            readonly id: string;
        } | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ProjectFinancialsPage_viewer">;
    } | null;
};
export type ProjectFinancialsPage_Query = {
    readonly response: ProjectFinancialsPage_QueryResponse;
    readonly variables: ProjectFinancialsPage_QueryVariables;
};



/*
query ProjectFinancialsPage_Query(
  $projectId: String
  $currentYear: Int
  $currentMonth: Int
  $currentMonthLastDay: Int
) {
  viewer {
    actualPersonId
    project(id: $projectId) {
      id
    }
    component(name: "project_budget_v3", projectId: $projectId)
    ...ProjectFinancialsPage_viewer_90Dg7
    id
  }
}

fragment ActualDetailsTable_project on ProjectType {
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        startDate
        endDate
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ...DetailsTable_project
}

fragment BudgetData_company on Company {
  tier
  ...HighLevelBudgetNumbers_company
}

fragment BudgetData_project_3GwKxC on ProjectType {
  ...Chart_project
  ...HighLevelBudgetNumbers_project_3GwKxC
  ...Totals_project
  ...InvoiceChart_project
  ...RevenueRecognition_project
  id
  billable
  budgetType
}

fragment BudgetPageHeader_company on Company {
  id
  tier
  sageIntacctEnabled
  sageIntacctTimeRegsFromForecast
  currency
  sageIntacctConnectionEnabled
}

fragment BudgetPageHeader_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  budgetType
  budget
  defaultPeriodBudgetType
  rateCard {
    currency
    id
  }
  estimationUnit
  billable
  manualProgressOnProjectEnabled
  manualProgressOnPhasesEnabled
  manualProgressOnTasksEnabled
}

fragment BudgetPage_company on Company {
  tier
  ...BudgetPageHeader_company
  ...BudgetData_company
  ...Details_company
}

fragment BudgetPage_project_90Dg7 on ProjectType {
  id
  financialDataAvailability
  ...BudgetPageHeader_project
  ...BudgetData_project_3GwKxC
  ...TimeBudgetData_project_3GwKxC
  ...Details_project
  ...InvoiceDetails_project
  ...TimeDetails_project
  ...ExpenseDetails_project
  manualProgressOnProjectEnabled
  manualProgressOnPhasesEnabled
  manualProgressOnTasksEnabled
  budgetType
}

fragment Chart_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment DetailsTable_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment Details_company on Company {
  id
  isUsingProjectAllocation
}

fragment Details_project on ProjectType {
  id
  useBaseline
  budgetType
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  estimationUnit
  billable
  ...DetailsTable_project
  ...ActualDetailsTable_project
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
}

fragment ExpenseDetailsTable_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment ExpenseDetails_project on ProjectType {
  id
  useBaseline
  budgetType
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  billable
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
  ...ExpenseDetailsTable_project
}

fragment ExpenseRevenueRecognition_project on ProjectType {
  id
  billable
  plannedBillableExpenses
  projectRevRecFirstDateYear
  projectRevRecFirstDateMonth
  projectRevRecFirstDateDay
  projectRevRecLastDateYear
  projectRevRecLastDateMonth
  projectRevRecLastDateDay
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        startDate
        endDate
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment HighLevelBudgetNumbers_company on Company {
  tier
  id
  currency
}

fragment HighLevelBudgetNumbers_project_3GwKxC on ProjectType {
  id
  useBaseline
  hasInvoices
  budget
  budgetType
  defaultPeriodBudgetType
  timeRegBasedPlusDoneScopeCompletion
  rateCard {
    currency
    id
  }
  financialNumbers(convertToProjectCurrency: true) {
    baselineRevenue
    actualRevenue
    baselineProfit
    actualProfit
    totalRevenueProfitAtCompletion
    baselineMargin
    actualMargin
    totalRevenueMarginAtCompletion
    billableActualTimeAndExpenses
    actualCost
    billableForecastTimeAndExpensesToComplete
    forecastCostToComplete
    totalCostAtCompletion
    billableTotalTimeAndExpensesAtCompletion
    invoiced
    paid
    recognitionProfit
    recognitionProfitPercentage
    totalRevenueRecognition
    projectTotalForecastTimeAndExpensesToCompleteInPast
    projectTotalForecastCostToCompleteInPast
    baselineCost
    baselineVsForecastCost
    allActualTimeAndExpenses
    allForecastTimeAndExpensesToComplete
    allTotalTimeAndExpensesAtCompletion
    baselineTimeAndExpenses
    baselineVsBillableTotalTimeAndExpensesAtCompletion
    estimatedCost
    planVsTotalCostAtCompletion
    billablePlannedTimeAndExpenses
  }
  financialNumbersToCurrentMonth: financialNumbers(endYear: $currentYear, endMonth: $currentMonth, endDay: $currentMonthLastDay, convertToProjectCurrency: true) {
    recognitionLockedProfit
    recognitionLockedProfitPercentage
    recognitionLockedRevenue
  }
  expenseItems(first: 10000) {
    edges {
      node {
        approved
        billable
        partOfFixedPrice
        expenseYear
        expenseMonth
        expenseDay
        price
        cost
        quantity
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment HighLevelTimeNumbers_project_3GwKxC on ProjectType {
  id
  useBaseline
  billable
  financialNumbersToCurrentMonth: financialNumbers(endYear: $currentYear, endMonth: $currentMonth, endDay: $currentMonthLastDay, convertToProjectCurrency: true) {
    registeredMinutes
    billableActualMinutes
    nonBillableActualMinutes
    forecastMinutes
    baselineMinutes
    scopeApprovedMinutes
    projectedTotalMinutes
    projectedBillableMinutes
    projectedNonBillableMinutes
  }
}

fragment InvoiceChart_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment InvoiceDetailsTable_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment InvoiceDetails_project on ProjectType {
  ...InvoiceDetailsTable_project
  budgetType
}

fragment ProjectFinancialsPage_viewer_90Dg7 on Viewer {
  id
  actualPersonId
  email
  project(id: $projectId) {
    id
    name
    budgetType
    useBaseline
    projectEndYear
    projectEndMonth
    projectEndDay
    companyProjectId
    customProjectId
    hasInvoices
    sageProject {
      id
      sageProjectId
    }
    expenseItems(first: 10000) {
      edges {
        node {
          id
          category {
            id
            name
          }
          phase {
            id
            name
          }
          name
          approved
          expenseYear
          expenseMonth
          expenseDay
          billable
          price
          cost
          quantity
          planned
          createdAt
          invoiced
          person {
            id
            fullName
            profilePictureId
            profilePictureDefaultId
          }
          __typename
        }
        cursor
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    financialSourceSettings {
      plannedCost
      plannedRevenue
      actualCost
      actualRevenue
      forecastCost
      forecastRevenue
      id
    }
    ...BudgetPage_project_90Dg7
    ...expensesPage_project
    ...ratesAndInternalCostPage_project
    ...RatesAndInternalCostLitePage_project
    ...RevenueRecognitionPage_project
    ...ProjectHeader_project
    ...SecondaryNavigation_project
  }
  psProject(companyProjectId: $projectId) {
    ...ProjectHeader_psProject
    id
  }
  company {
    id
    tier
    ...BudgetPage_company
    ...expensesPage_company
    ...ratesAndInternalCostPage_company
    ...RatesAndInternalCostLitePage_company
    ...RevenueRecognitionPage_company
    modules {
      moduleType
      id
    }
    sageIntacctConnectionEnabled
  }
}

fragment ProjectHeader_project on ProjectType {
  id
  companyProjectId
  ...ProjectIndicatorJS_project
  name
  projectColor
  isInProjectGroup
  projectGroupCompanyId
  projectGroupName
  projectGroupColor
  useBaseline
  budgetType
  sprintTimeBox
}

fragment ProjectHeader_psProject on ProjectServiceProjectType {
  name
  psProgram {
    id
    name
    color
    prefix
    isViewerProgramMember
  }
}

fragment ProjectIndicatorJS_project on ProjectType {
  name
  companyProjectId
  customProjectId
  projectColor
}

fragment RateCardDropdown_rateCards on RateCardTypeEdge {
  node {
    id
    name
    currency
    parentRateCardId
    disabled
  }
}

fragment RatesAndInternalCostLitePage_company on Company {
  id
  currency
}

fragment RatesAndInternalCostLitePage_project on ProjectType {
  id
  budgetType
  flatRate
  flatCost
}

fragment RevenueRecognitionPage_company on Company {
  id
  currency
}

fragment RevenueRecognitionPage_project on ProjectType {
  id
  rateCard {
    id
    currency
  }
  budgetType
  ...RevenueRecognition_project
  ...TimeRevenueRecognition_project
  ...ExpenseRevenueRecognition_project
}

fragment RevenueRecognition_project on ProjectType {
  id
  budgetType
  billable
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  projectRevRecFirstDateYear
  projectRevRecFirstDateMonth
  projectRevRecFirstDateDay
  projectRevRecLastDateYear
  projectRevRecLastDateMonth
  projectRevRecLastDateDay
  estimationUnit
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        locked
        startDate
        endDate
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  rateCard {
    currency
    id
  }
}

fragment SecondaryNavigation_project on ProjectType {
  companyProjectId
  customProjectId
  sprintTimeBox
  budgetType
  projectGroupId
  useBaseline
  hasInvoices
  financialSourceSettings {
    plannedCost
    plannedRevenue
    actualCost
    actualRevenue
    forecastCost
    forecastRevenue
    id
  }
}

fragment TimeBudgetData_project_3GwKxC on ProjectType {
  ...TimeChart_project
  ...TimeTotals_project
  ...HighLevelTimeNumbers_project_3GwKxC
}

fragment TimeChart_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
}

fragment TimeDetails_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  ...DetailsTable_project
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
}

fragment TimeRevenueRecognition_project on ProjectType {
  id
  billable
  budgetWork
  budgetType
  defaultPeriodBudgetType
  projectRevRecFirstDateYear
  projectRevRecFirstDateMonth
  projectRevRecFirstDateDay
  projectRevRecLastDateYear
  projectRevRecLastDateMonth
  projectRevRecLastDateDay
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        startDate
        endDate
        locked
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment TimeTotals_project on ProjectType {
  id
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
}

fragment Totals_project on ProjectType {
  id
  budgetType
  defaultPeriodBudgetType
  projectFirstDateYear
  projectFirstDateMonth
  projectFirstDateDay
  projectLastDateYear
  projectLastDateMonth
  projectLastDateDay
  estimationUnit
  financialSourceSettings {
    plannedHours
    plannedRevenue
    plannedCost
    forecastHours
    forecastRevenue
    forecastCost
    actualHours
    actualRevenue
    actualCost
    id
  }
  useFixedPriceForBaselineRevenue
}

fragment expenseRow_company on Company {
  id
  expenseCategories(first: 10000) {
    edges {
      node {
        id
        name
        disabled
      }
    }
  }
}

fragment expenseRow_project on ProjectType {
  id
  budgetType
  companyProjectId
}

fragment expensesPage_company on Company {
  ...expenseRow_company
  id
  currency
  newXeroEnabled
  sageIntacctConnectionEnabled
  expenseCategories(first: 10000) {
    edges {
      node {
        id
        name
        disabled
      }
    }
  }
}

fragment expensesPage_project on ProjectType {
  ...expenseRow_project
  id
  companyProjectId
  billable
  budgetType
  status
  rateCard {
    id
    currency
  }
  expenseItems(first: 10000) {
    edges {
      node {
        id
        category {
          id
          name
        }
        phase {
          id
          name
        }
        name
        approved
        expenseYear
        expenseMonth
        expenseDay
        billable
        partOfFixedPrice
        price
        cost
        quantity
        planned
        createdAt
        invoiced
        person {
          id
          fullName
          profilePictureId
          profilePictureDefaultId
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  fixedPriceLocks(first: 1000) {
    edges {
      node {
        id
        startDate
        endDate
        locked
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ratesAndInternalCostPage_company on Company {
  id
  currency
  roles(first: 10000) {
    edges {
      node {
        id
        name
      }
    }
  }
  exchangeRates(first: 10000) {
    edges {
      node {
        id
        currency
        rate
      }
    }
  }
  rateCards(first: 10000) {
    edges {
      ...RateCardDropdown_rateCards
      node {
        id
        name
        defaultRate
        currency
        parentRateCardId
        rates(first: 10000) {
          edges {
            node {
              id
              rate
              defaultRate
              startDate
              role {
                id
                name
              }
            }
          }
        }
      }
    }
  }
}

fragment ratesAndInternalCostPage_project on ProjectType {
  id
  budget
  budgetType
  taskCostCalculationType
  unassignedTaskHourlyCost
  projectPersons(first: 1000) {
    edges {
      node {
        id
        person {
          id
          isViewer
          fullName
          initials
          profilePictureId
          profilePictureDefaultId
          active
          permissions
          costPeriods(first: 10000) {
            edges {
              node {
                id
                startDay
                startMonth
                startYear
                cost
              }
            }
          }
        }
        role {
          id
          name
        }
      }
    }
  }
  rateCard {
    id
    currency
    name
    defaultRate
    parentRateCardId
    disabledRoles {
      id
    }
    rates(first: 10000) {
      edges {
        node {
          id
          rate
          defaultRate
          startDate
          role {
            id
            name
          }
        }
      }
    }
  }
  invoices(first: 100000000) {
    edges {
      node {
        status
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentYear",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentMonth",
    "type": "Int"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentMonthLastDay",
    "type": "Int"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "projectId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v6 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "project_budget_v3"
    },
    (v5/*: any*/)
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v9 = [
  (v3/*: any*/),
  (v7/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "billable",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiced",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureDefaultId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualCost",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualRevenue",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultRate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "parentRateCardId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": (v8/*: any*/),
  "concreteType": "RateTypeConnection",
  "kind": "LinkedField",
  "name": "rates",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RateTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Rate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v24/*: any*/),
            (v22/*: any*/),
            (v25/*: any*/),
            (v26/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "rates(first:10000)"
},
v28 = {
  "kind": "Literal",
  "name": "convertToProjectCurrency",
  "value": true
},
v29 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectFinancialsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "currentMonth",
                "variableName": "currentMonth"
              },
              {
                "kind": "Variable",
                "name": "currentMonthLastDay",
                "variableName": "currentMonthLastDay"
              },
              {
                "kind": "Variable",
                "name": "currentYear",
                "variableName": "currentYear"
              },
              (v5/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectFinancialsPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectFinancialsPage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasInvoices",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SageProjectType",
                "kind": "LinkedField",
                "name": "sageProject",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sageProjectId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "ExpenseItemTypeConnection",
                "kind": "LinkedField",
                "name": "expenseItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseItemTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExpenseCategory",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhaseType",
                            "kind": "LinkedField",
                            "name": "phase",
                            "plural": false,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "approved",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseDay",
                            "storageKey": null
                          },
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "price",
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "quantity",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "planned",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdAt",
                            "storageKey": null
                          },
                          (v12/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "partOfFixedPrice",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "expenseItems(first:10000)"
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "Project_expenseItems",
                "kind": "LinkedHandle",
                "name": "expenseItems"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinancialSourceSettings",
                "kind": "LinkedField",
                "name": "financialSourceSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedRevenue",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastRevenue",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "plannedHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastHours",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualHours",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "financialDataAvailability",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "defaultPeriodBudgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v3/*: any*/),
                  (v7/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "estimationUnit",
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnProjectEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnPhasesEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "manualProgressOnTasksEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeRegBasedPlusDoneScopeCompletion",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  (v28/*: any*/)
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineRevenue",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueProfitAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actualMargin",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueMarginAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualTimeAndExpenses",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastCostToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionProfitPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalRevenueRecognition",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastTimeAndExpensesToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectTotalForecastCostToCompleteInPast",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsForecastCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allActualTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allForecastTimeAndExpensesToComplete",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineTimeAndExpenses",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineVsBillableTotalTimeAndExpensesAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "estimatedCost",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "planVsTotalCostAtCompletion",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billablePlannedTimeAndExpenses",
                    "storageKey": null
                  }
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "alias": "financialNumbersToCurrentMonth",
                "args": [
                  (v28/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "endDay",
                    "variableName": "currentMonthLastDay"
                  },
                  {
                    "kind": "Variable",
                    "name": "endMonth",
                    "variableName": "currentMonth"
                  },
                  {
                    "kind": "Variable",
                    "name": "endYear",
                    "variableName": "currentYear"
                  }
                ],
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfit",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedProfitPercentage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "recognitionLockedRevenue",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "registeredMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nonBillableActualMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "forecastMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "baselineMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "scopeApprovedMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedTotalMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedBillableMinutes",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "projectedNonBillableMinutes",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecFirstDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectRevRecLastDateDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "ProjectFixedPriceLockTypeConnection",
                "kind": "LinkedField",
                "name": "fixedPriceLocks",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectFixedPriceLockTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectFixedPriceLockType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "locked",
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endDate",
                            "storageKey": null
                          },
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": "fixedPriceLocks(first:1000)"
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_fixedPriceLocks",
                "kind": "LinkedHandle",
                "name": "fixedPriceLocks"
              },
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taskCostCalculationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unassignedTaskHourlyCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v29/*: any*/),
                "concreteType": "ProjectPersonTypeConnection",
                "kind": "LinkedField",
                "name": "projectPersons",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectPersonTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProjectPerson",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "person",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isViewer",
                                "storageKey": null
                              },
                              (v13/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "initials",
                                "storageKey": null
                              },
                              (v14/*: any*/),
                              (v15/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "active",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "permissions",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": (v8/*: any*/),
                                "concreteType": "CostPeriodTypeConnection",
                                "kind": "LinkedField",
                                "name": "costPeriods",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CostPeriodTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CostPeriod",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startDay",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startMonth",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "startYear",
                                            "storageKey": null
                                          },
                                          (v11/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "costPeriods(first:10000)"
                              }
                            ],
                            "storageKey": null
                          },
                          (v26/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "projectPersons(first:1000)"
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100000000
                  }
                ],
                "concreteType": "InvoiceTypeConnection",
                "kind": "LinkedField",
                "name": "invoices",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoiceType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v30/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "invoices(first:100000000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flatRate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flatCost",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetWork",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "plannedBillableExpenses",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isInProjectGroup",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupCompanyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sprintTimeBox",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectGroupId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "companyProjectId",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectServiceProjectType",
            "kind": "LinkedField",
            "name": "psProject",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProgramType",
                "kind": "LinkedField",
                "name": "psProgram",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "prefix",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isViewerProgramMember",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctTimeRegsFromForecast",
                "storageKey": null
              },
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctConnectionEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isUsingProjectAllocation",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "ExpenseCategoryTypeConnection",
                "kind": "LinkedField",
                "name": "expenseCategories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseCategoryTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "expenseCategories(first:10000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "newXeroEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "roles(first:10000)"
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "ExchangeRateTypeConnection",
                "kind": "LinkedField",
                "name": "exchangeRates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExchangeRateTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExchangeRate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v21/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "exchangeRates(first:10000)"
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "RateCardTypeConnection",
                "kind": "LinkedField",
                "name": "rateCards",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateCardTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateCard",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v21/*: any*/),
                          (v23/*: any*/),
                          (v31/*: any*/),
                          (v22/*: any*/),
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "rateCards(first:10000)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleType",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ProjectFinancialsPage_Query",
    "operationKind": "query",
    "text": "query ProjectFinancialsPage_Query(\n  $projectId: String\n  $currentYear: Int\n  $currentMonth: Int\n  $currentMonthLastDay: Int\n) {\n  viewer {\n    actualPersonId\n    project(id: $projectId) {\n      id\n    }\n    component(name: \"project_budget_v3\", projectId: $projectId)\n    ...ProjectFinancialsPage_viewer_90Dg7\n    id\n  }\n}\n\nfragment ActualDetailsTable_project on ProjectType {\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...DetailsTable_project\n}\n\nfragment BudgetData_company on Company {\n  tier\n  ...HighLevelBudgetNumbers_company\n}\n\nfragment BudgetData_project_3GwKxC on ProjectType {\n  ...Chart_project\n  ...HighLevelBudgetNumbers_project_3GwKxC\n  ...Totals_project\n  ...InvoiceChart_project\n  ...RevenueRecognition_project\n  id\n  billable\n  budgetType\n}\n\nfragment BudgetPageHeader_company on Company {\n  id\n  tier\n  sageIntacctEnabled\n  sageIntacctTimeRegsFromForecast\n  currency\n  sageIntacctConnectionEnabled\n}\n\nfragment BudgetPageHeader_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  budgetType\n  budget\n  defaultPeriodBudgetType\n  rateCard {\n    currency\n    id\n  }\n  estimationUnit\n  billable\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n}\n\nfragment BudgetPage_company on Company {\n  tier\n  ...BudgetPageHeader_company\n  ...BudgetData_company\n  ...Details_company\n}\n\nfragment BudgetPage_project_90Dg7 on ProjectType {\n  id\n  financialDataAvailability\n  ...BudgetPageHeader_project\n  ...BudgetData_project_3GwKxC\n  ...TimeBudgetData_project_3GwKxC\n  ...Details_project\n  ...InvoiceDetails_project\n  ...TimeDetails_project\n  ...ExpenseDetails_project\n  manualProgressOnProjectEnabled\n  manualProgressOnPhasesEnabled\n  manualProgressOnTasksEnabled\n  budgetType\n}\n\nfragment Chart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment DetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment Details_company on Company {\n  id\n  isUsingProjectAllocation\n}\n\nfragment Details_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  billable\n  ...DetailsTable_project\n  ...ActualDetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment ExpenseDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment ExpenseDetails_project on ProjectType {\n  id\n  useBaseline\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  billable\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  ...ExpenseDetailsTable_project\n}\n\nfragment ExpenseRevenueRecognition_project on ProjectType {\n  id\n  billable\n  plannedBillableExpenses\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HighLevelBudgetNumbers_company on Company {\n  tier\n  id\n  currency\n}\n\nfragment HighLevelBudgetNumbers_project_3GwKxC on ProjectType {\n  id\n  useBaseline\n  hasInvoices\n  budget\n  budgetType\n  defaultPeriodBudgetType\n  timeRegBasedPlusDoneScopeCompletion\n  rateCard {\n    currency\n    id\n  }\n  financialNumbers(convertToProjectCurrency: true) {\n    baselineRevenue\n    actualRevenue\n    baselineProfit\n    actualProfit\n    totalRevenueProfitAtCompletion\n    baselineMargin\n    actualMargin\n    totalRevenueMarginAtCompletion\n    billableActualTimeAndExpenses\n    actualCost\n    billableForecastTimeAndExpensesToComplete\n    forecastCostToComplete\n    totalCostAtCompletion\n    billableTotalTimeAndExpensesAtCompletion\n    invoiced\n    paid\n    recognitionProfit\n    recognitionProfitPercentage\n    totalRevenueRecognition\n    projectTotalForecastTimeAndExpensesToCompleteInPast\n    projectTotalForecastCostToCompleteInPast\n    baselineCost\n    baselineVsForecastCost\n    allActualTimeAndExpenses\n    allForecastTimeAndExpensesToComplete\n    allTotalTimeAndExpensesAtCompletion\n    baselineTimeAndExpenses\n    baselineVsBillableTotalTimeAndExpensesAtCompletion\n    estimatedCost\n    planVsTotalCostAtCompletion\n    billablePlannedTimeAndExpenses\n  }\n  financialNumbersToCurrentMonth: financialNumbers(endYear: $currentYear, endMonth: $currentMonth, endDay: $currentMonthLastDay, convertToProjectCurrency: true) {\n    recognitionLockedProfit\n    recognitionLockedProfitPercentage\n    recognitionLockedRevenue\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        approved\n        billable\n        partOfFixedPrice\n        expenseYear\n        expenseMonth\n        expenseDay\n        price\n        cost\n        quantity\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment HighLevelTimeNumbers_project_3GwKxC on ProjectType {\n  id\n  useBaseline\n  billable\n  financialNumbersToCurrentMonth: financialNumbers(endYear: $currentYear, endMonth: $currentMonth, endDay: $currentMonthLastDay, convertToProjectCurrency: true) {\n    registeredMinutes\n    billableActualMinutes\n    nonBillableActualMinutes\n    forecastMinutes\n    baselineMinutes\n    scopeApprovedMinutes\n    projectedTotalMinutes\n    projectedBillableMinutes\n    projectedNonBillableMinutes\n  }\n}\n\nfragment InvoiceChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetailsTable_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment InvoiceDetails_project on ProjectType {\n  ...InvoiceDetailsTable_project\n  budgetType\n}\n\nfragment ProjectFinancialsPage_viewer_90Dg7 on Viewer {\n  id\n  actualPersonId\n  email\n  project(id: $projectId) {\n    id\n    name\n    budgetType\n    useBaseline\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    companyProjectId\n    customProjectId\n    hasInvoices\n    sageProject {\n      id\n      sageProjectId\n    }\n    expenseItems(first: 10000) {\n      edges {\n        node {\n          id\n          category {\n            id\n            name\n          }\n          phase {\n            id\n            name\n          }\n          name\n          approved\n          expenseYear\n          expenseMonth\n          expenseDay\n          billable\n          price\n          cost\n          quantity\n          planned\n          createdAt\n          invoiced\n          person {\n            id\n            fullName\n            profilePictureId\n            profilePictureDefaultId\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    financialSourceSettings {\n      plannedCost\n      plannedRevenue\n      actualCost\n      actualRevenue\n      forecastCost\n      forecastRevenue\n      id\n    }\n    ...BudgetPage_project_90Dg7\n    ...expensesPage_project\n    ...ratesAndInternalCostPage_project\n    ...RatesAndInternalCostLitePage_project\n    ...RevenueRecognitionPage_project\n    ...ProjectHeader_project\n    ...SecondaryNavigation_project\n  }\n  psProject(companyProjectId: $projectId) {\n    ...ProjectHeader_psProject\n    id\n  }\n  company {\n    id\n    tier\n    ...BudgetPage_company\n    ...expensesPage_company\n    ...ratesAndInternalCostPage_company\n    ...RatesAndInternalCostLitePage_company\n    ...RevenueRecognitionPage_company\n    modules {\n      moduleType\n      id\n    }\n    sageIntacctConnectionEnabled\n  }\n}\n\nfragment ProjectHeader_project on ProjectType {\n  id\n  companyProjectId\n  ...ProjectIndicatorJS_project\n  name\n  projectColor\n  isInProjectGroup\n  projectGroupCompanyId\n  projectGroupName\n  projectGroupColor\n  useBaseline\n  budgetType\n  sprintTimeBox\n}\n\nfragment ProjectHeader_psProject on ProjectServiceProjectType {\n  name\n  psProgram {\n    id\n    name\n    color\n    prefix\n    isViewerProgramMember\n  }\n}\n\nfragment ProjectIndicatorJS_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n\nfragment RateCardDropdown_rateCards on RateCardTypeEdge {\n  node {\n    id\n    name\n    currency\n    parentRateCardId\n    disabled\n  }\n}\n\nfragment RatesAndInternalCostLitePage_company on Company {\n  id\n  currency\n}\n\nfragment RatesAndInternalCostLitePage_project on ProjectType {\n  id\n  budgetType\n  flatRate\n  flatCost\n}\n\nfragment RevenueRecognitionPage_company on Company {\n  id\n  currency\n}\n\nfragment RevenueRecognitionPage_project on ProjectType {\n  id\n  rateCard {\n    id\n    currency\n  }\n  budgetType\n  ...RevenueRecognition_project\n  ...TimeRevenueRecognition_project\n  ...ExpenseRevenueRecognition_project\n}\n\nfragment RevenueRecognition_project on ProjectType {\n  id\n  budgetType\n  billable\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  estimationUnit\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        locked\n        startDate\n        endDate\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  rateCard {\n    currency\n    id\n  }\n}\n\nfragment SecondaryNavigation_project on ProjectType {\n  companyProjectId\n  customProjectId\n  sprintTimeBox\n  budgetType\n  projectGroupId\n  useBaseline\n  hasInvoices\n  financialSourceSettings {\n    plannedCost\n    plannedRevenue\n    actualCost\n    actualRevenue\n    forecastCost\n    forecastRevenue\n    id\n  }\n}\n\nfragment TimeBudgetData_project_3GwKxC on ProjectType {\n  ...TimeChart_project\n  ...TimeTotals_project\n  ...HighLevelTimeNumbers_project_3GwKxC\n}\n\nfragment TimeChart_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n}\n\nfragment TimeDetails_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  ...DetailsTable_project\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment TimeRevenueRecognition_project on ProjectType {\n  id\n  billable\n  budgetWork\n  budgetType\n  defaultPeriodBudgetType\n  projectRevRecFirstDateYear\n  projectRevRecFirstDateMonth\n  projectRevRecFirstDateDay\n  projectRevRecLastDateYear\n  projectRevRecLastDateMonth\n  projectRevRecLastDateDay\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        locked\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TimeTotals_project on ProjectType {\n  id\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n}\n\nfragment Totals_project on ProjectType {\n  id\n  budgetType\n  defaultPeriodBudgetType\n  projectFirstDateYear\n  projectFirstDateMonth\n  projectFirstDateDay\n  projectLastDateYear\n  projectLastDateMonth\n  projectLastDateDay\n  estimationUnit\n  financialSourceSettings {\n    plannedHours\n    plannedRevenue\n    plannedCost\n    forecastHours\n    forecastRevenue\n    forecastCost\n    actualHours\n    actualRevenue\n    actualCost\n    id\n  }\n  useFixedPriceForBaselineRevenue\n}\n\nfragment expenseRow_company on Company {\n  id\n  expenseCategories(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        disabled\n      }\n    }\n  }\n}\n\nfragment expenseRow_project on ProjectType {\n  id\n  budgetType\n  companyProjectId\n}\n\nfragment expensesPage_company on Company {\n  ...expenseRow_company\n  id\n  currency\n  newXeroEnabled\n  sageIntacctConnectionEnabled\n  expenseCategories(first: 10000) {\n    edges {\n      node {\n        id\n        name\n        disabled\n      }\n    }\n  }\n}\n\nfragment expensesPage_project on ProjectType {\n  ...expenseRow_project\n  id\n  companyProjectId\n  billable\n  budgetType\n  status\n  rateCard {\n    id\n    currency\n  }\n  expenseItems(first: 10000) {\n    edges {\n      node {\n        id\n        category {\n          id\n          name\n        }\n        phase {\n          id\n          name\n        }\n        name\n        approved\n        expenseYear\n        expenseMonth\n        expenseDay\n        billable\n        partOfFixedPrice\n        price\n        cost\n        quantity\n        planned\n        createdAt\n        invoiced\n        person {\n          id\n          fullName\n          profilePictureId\n          profilePictureDefaultId\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  fixedPriceLocks(first: 1000) {\n    edges {\n      node {\n        id\n        startDate\n        endDate\n        locked\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ratesAndInternalCostPage_company on Company {\n  id\n  currency\n  roles(first: 10000) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  exchangeRates(first: 10000) {\n    edges {\n      node {\n        id\n        currency\n        rate\n      }\n    }\n  }\n  rateCards(first: 10000) {\n    edges {\n      ...RateCardDropdown_rateCards\n      node {\n        id\n        name\n        defaultRate\n        currency\n        parentRateCardId\n        rates(first: 10000) {\n          edges {\n            node {\n              id\n              rate\n              defaultRate\n              startDate\n              role {\n                id\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ratesAndInternalCostPage_project on ProjectType {\n  id\n  budget\n  budgetType\n  taskCostCalculationType\n  unassignedTaskHourlyCost\n  projectPersons(first: 1000) {\n    edges {\n      node {\n        id\n        person {\n          id\n          isViewer\n          fullName\n          initials\n          profilePictureId\n          profilePictureDefaultId\n          active\n          permissions\n          costPeriods(first: 10000) {\n            edges {\n              node {\n                id\n                startDay\n                startMonth\n                startYear\n                cost\n              }\n            }\n          }\n        }\n        role {\n          id\n          name\n        }\n      }\n    }\n  }\n  rateCard {\n    id\n    currency\n    name\n    defaultRate\n    parentRateCardId\n    disabledRoles {\n      id\n    }\n    rates(first: 10000) {\n      edges {\n        node {\n          id\n          rate\n          defaultRate\n          startDate\n          role {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n  invoices(first: 100000000) {\n    edges {\n      node {\n        status\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'd17b5c66c5a6f4b9af9c916681c7973a';
export default node;
